import { GetterTree } from 'vuex';
import { PhotoState } from './types';
import { RootState } from '../types';

export const getters: GetterTree<PhotoState, RootState> = {
  onlyPhoto: (state) => {
    const allPhotos = Object.values(state.photosByCameraId).flat();
    return allPhotos.filter((p) => p.isSlowmotion === undefined || p.isSlowmotion === false);
  },
  onlySlowmotion: (state) => {
    const allPhotos = Object.values(state.photosByCameraId).flat();
    return allPhotos.filter((p) => p.isSlowmotion);
  },
};
